import React, {useLayoutEffect, useState, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Text,
  View,
  Dimensions,
  Image,
  TouchableOpacity,
  ScrollView
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {NavigationContainer} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import {blackNavigationTheme} from '../utils/navigationTheme';
import {connect} from 'react-redux';
import {UserInfo, fetchAndStoreUserInfo, fetchUserInfo} from '../actions/userAction';
import {GetBothSettings} from '../actions/userAction';
import {SetOrdersUpdated, GetOrderList} from '../actions/orderActions';
import {SetProductsUpdated} from '../actions/productAction';

import SignIn from './login/signin';
import OrderList from './orders/orderlist';
import OrderDetail from './orders/orderdetail';
import ItemsDetail from './orders/items_detail';
import AddItemToOrder from './orders/add_item_to_order';
import OrderSearch from './orders/order_search';
import Settings from './directPrinting/settings';
import PPMTestDataGenerator from './groovlytics/PPMTestDataGenerator';
import InventoryKitOptions from './products/inventory_kit_options';
import Dashboard from './groovlytics/dashboard';
import ScanPack from './scanpack/scanpack';
import ScanPackItem from './scanpack/scanpack_item';
import ProductEdit from './scanpack/product_edit';
import ProductDetail from './products/product_detail';
import ProductSearch from './products/product_search';
import PutWall from './putwall/put_wall';
import Drawer from './drawer/drawer';
import CartCompleteConfetti from './CartCompleteConfetti';
import InventoryReport from './receive_recount/inventoryReport';
import ArchivedReceivingReports from './receive_recount/archivedReceivingReports';
import PushInventory from './inventoryReports/pushInventory';
import {
  ScanReceive,
  ScanRecount,
  ProductRecount,
  ProductReceive,
  CountReceive,
  CountRecount,
  ProductListReceive,
  ProductListRecount
} from './receive_recount';
import SyncButton from './actionButton/sync';
import toggle from '../../assets/toggle1.png';
import {navigationRef} from './root_navigation';
import Close from '../../assets/closeicon.png';
import {LinearGradient} from 'expo-linear-gradient';
import {fontFamily} from '../helpers/fontFamily';
import * as RootNavigation from './root_navigation';
import {isProductFirstWorkflow} from '../helpers/productFirstWorkflow';
import {resetProductFirst} from '../actions/productFirstActions';
import inventory_kit_options from './products/inventory_kit_options';
import PackingCam from './scanpack/packing_cam';
import {CheckIsMenuOpen, MountComponent} from '../actions/menuActions';
import {
  loadMenuState,
  saveMenuState,
  MENU_EXPANDED,
  MENU_COLLAPSED,
  MENU_HIDDEN
} from '../utils/menuPreferences';
import ShippingLabel from './orders/shipping_label';
import ViewInventoryReport from './inventoryReports/viewInventoryReport';
import CustomHeader from '../commons/customHeader';
import PrinterShow from './directPrinting/printerShow';
import printJob from './printJob';
import AllOrders from './orders/all_orders';
import { fetchCompletedOrdersLocally, updateOrdersFlag } from '../DexieDbUtils';
import InterNetCheck from './internateConnectionCheck';
import { detectOrdersDiscrepancies, SetDashboardData } from '../actions/scanpackAction';
import NetInfo from '@react-native-community/netinfo';
import I18n from 'i18n-js';
import { getScanBarCode } from './scanpack/apiStorage';
import { initDatabase } from './scanpack/db';
import { SubmitLog } from '../actions/saveLogAction';
import ScanToCartHome from './scanToCartScanning';
import ProductSearchGrid from './products/ProductSearchGrid';
import ScanPackScanning from './ScanpackScanning';
import {SCANPACK_ORDER_WINDOW_NAME_PREFIX} from '../constants';
import AutomationRulesScreen from './rulesEngine/AutomationRulesScreen';
import CostCalculatorScreen from './costCalculator/CostCalculatorScreen';
import AdminTenants from './adminTools/AdminTenants';
import AdminTenantPage from './adminTools/AdminTenantPage';
import AdminUtilities from './adminTools/AdminUtilities';
import {
  ADMIN_LANDING_ROUTE,
  CUSTOMER_LANDING_ROUTE,
  getLandingRoute,
  readPersistedUserInfo
} from '../helpers/adminTenant';

const TIMER_MS = 70000; // 70 seconds
const DATA = {
  filter: 'all',
  order: 'DESC',
  limit: 20,
  offset: '0',
  app: '',
  product_search_toggle: undefined
}
const Stack = createStackNavigator();

const resolveInitialRoute = async () => {
  const accessToken = await AsyncStorage.getItem('access_token');
  if (!accessToken) return 'SignIn';
  const persisted = await readPersistedUserInfo();
  if (persisted) return getLandingRoute(persisted);
  const url = await AsyncStorage.getItem('url');
  // Unknown tenant lands as a customer; backend GROOV-5180 gates admin data, not this route.
  const fetched = await fetchAndStoreUserInfo(url, accessToken).catch(() => null);
  return getLandingRoute(fetched);
};

const getScanPackOrderFromWindowName = () => {
  if (typeof window === 'undefined' || !window.name) return null;
  if (!window.name.startsWith(SCANPACK_ORDER_WINDOW_NAME_PREFIX)) return null;

  return decodeURIComponent(
    window.name.replace(SCANPACK_ORDER_WINDOW_NAME_PREFIX, '')
  );
};

function Main(props) {
  const disPatch = useDispatch();
  const useScanpackV2 = useSelector(state => state.features?.useScanpackScanningV2);
  const ScanPackItemComponent = useScanpackV2 ? ScanPackScanning : ScanPackItem;
  const [token, setToken] = useState('');
  const [show, setShow] = useState(false);
  const [initialRoute, setInitialRoute] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    Dimensions.get('window').width
  );
  let [navShow, setNavShow] = useState(true);
  let [openDrawer, handelDrawer] = useState(false);
  const [menuMode, setMenuMode] = useState(MENU_EXPANDED);
  const [currentRoute, setCurrentRoute] = useState('');
  const menuLoadedRef = useRef(false);
  let [restartFlag, restartHandel] = useState(false);
  let [alertShow, alertShowHandle] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const { mountComponent} = useSelector(state => state.user);
  const pickComplete = useSelector(state => state.scanToCart?.activeCart?.isPicked);
  const scanPackWorkflow = useSelector(
    state => state.user.settings?.data?.scan_pack_workflow
  );
  const putWallRedirectedRef = useRef(false);

  useEffect(() => {
    if (
      isProductFirstWorkflow(scanPackWorkflow) &&
      !putWallRedirectedRef.current &&
      navigationRef.current?.getCurrentRoute()?.name === 'ScanPack'
    ) {
      putWallRedirectedRef.current = true;
      RootNavigation.reset('PutWall');
    }
  }, [scanPackWorkflow]);
  //hook that will handle the language translation
    useEffect(() => {
      // Subscribe to network state updates
      const unsubscribe = NetInfo.addEventListener((state) => {
        setIsConnected( state.isConnected);
      });
      // Unsubscribe when component unmounts
      return () => unsubscribe();
    }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ''; // Required for Chrome to show confirmation dialog
    };

    !isConnected && window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup the event when component unmounts
    return () => {
      !isConnected &&  window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isConnected]);

  useEffect(() => {
    // Initialize database
    const setup = async () => {
      try {
        await initDatabase();
        
        // Try to load cached data first
        const cachedProducts = await getScanBarCode();
        console.log('cachedProducts',cachedProducts)
        if (cachedProducts) setProducts(cachedProducts.data);
        // const cachedUsers = await getUsers();
        // if (cachedUsers) setUsers(cachedUsers.data);
        
        // const cachedOrders = await getOrders();
        // if (cachedOrders) setOrders(cachedOrders.data);
        
        // const cachedCategories = await getCategories();
        // if (cachedCategories) setCategories(cachedCategories.data);
        
        // const cachedSettings = await getSettings();
        // if (cachedSettings) setSettings(cachedSettings.data);
        
        setIsLoading(false);
      } catch (error) {
        console.error('Error during setup:', error);
        setIsLoading(false);
      }
    };
    
    setup();
  }, [])
  useLayoutEffect(() => {
    function updateSize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  useEffect(() => {
    props.socketFun();
  }, []);

  useEffect(() => {
    let ignore = false;
    resolveInitialRoute()
      .catch(() => CUSTOMER_LANDING_ROUTE)
      .then(route => {
        if (ignore) return;
        // Customer landings get Redux userInfo from ScanPack's UserInfo(); the admin landing makes
        // no customer calls, so load it here or the menu state and headers read a null user.
        if (route === ADMIN_LANDING_ROUTE) disPatch(fetchUserInfo());
        setInitialRoute(route);
      });
    return () => {
      ignore = true;
    };
  }, []);

  useEffect(() => {
    const asyncEffect = async () => {
      if(props.progressCount >= 100 && props.updateOrders){
        disPatch(SetOrdersUpdated(props.bulkActionResult || true));
        props.restProgress();
      }
      if(props.progressCount >= 100 && props.updateProducts){
        disPatch(SetProductsUpdated());
        props.restProgress();
      }
    };

    asyncEffect();
  }, [props]);

  AsyncStorage.getItem('access_token').then(keyValue => {
    setToken(keyValue);
    setShow(true);
    return keyValue;
  });

  useEffect(() => {
    const orderNumber = getScanPackOrderFromWindowName();

    if (show && token && initialRoute && orderNumber) {
      window.name = '';
      navigationRef.current?.reset({
        index: 0,
        routes: [
          {
            name: 'ScanPack',
            params: {
              orderNumber,
              page: 'orderSearchList'
            }
          }
        ]
      });
    }
  }, [show, token, initialRoute]);

  props.getData(mountComponent)

  function DrawerButton({size}) {
    let fontSize = size ? (windowWidth < 800 ? size : '40px') : '40px';
    if (openDrawer) {
      return null;
    }
    return (
      <TouchableOpacity
        onPress={() => {
          handelDrawer((openDrawer = true));
          disPatch(CheckIsMenuOpen(true));
        }}
        style={{
          flex: 1,
          marginLeft: 20,
          justifyContent: 'center',
          width: '100%'
        }}>
        <i
          className="icon-menu"
          style={{color: 'white', fontSize: fontSize, marginLeft: -10}}></i>
        {/* <Image
          style={{
            width: 39,
            height: 31,
            color: "#fff",
            resizeMode: "contain",
          }}
          source={toggle}
        /> */}
      </TouchableOpacity>
    );
  }

  function closeDrawer() {
    handelDrawer((openDrawer = false));
    0;
    disPatch(CheckIsMenuOpen(false));
  }

  function closeDrawerFromContent() {
    if (window.innerWidth < 768) {
      closeDrawer();
    }
  }

  function toggleMenuMode() {
    setMenuMode(mode =>
      mode === MENU_COLLAPSED ? MENU_EXPANDED : MENU_COLLAPSED
    );
  }

  useEffect(() => {
    const saved = loadMenuState(props.userInfo);
    if (saved) {
      setMenuMode(saved.lastVisible);
      const visible = saved.state !== MENU_HIDDEN && window.innerWidth >= 768;
      handelDrawer((openDrawer = visible));
      disPatch(CheckIsMenuOpen(visible));
    }
    menuLoadedRef.current = true;
  }, [props.userInfo?.current_tenant, props.userInfo?.username]);

  useEffect(() => {
    if (!menuLoadedRef.current) return;
    saveMenuState(
      props.userInfo,
      openDrawer ? menuMode : MENU_HIDDEN,
      menuMode
    );
  }, [openDrawer, menuMode]);

  function navBarShow(position) {
    setNavShow((navShow = position));
  }

  function restartButton() {
    restartHandel((restartFlag = !restartFlag));
  }

  function changeHeading(num) {
    if (num === 0) {
      name = 'Scanned Item';
    }
    if (num === 1) {
      name = 'Next Item';
    }
    if (num === 2) {
      name = 'Unscanned Item';
    }
  }

  function syncButtonHandle() {
    alertShowHandle(true);
  }
  function checkFunctionHere() {
    disPatch(MountComponent(!mountComponent))
  }

  useEffect(() => {
    const interval = setInterval(async () => {
      let token = await AsyncStorage.getItem('access_token');
      let info = await AsyncStorage.getItem('userInfo');
      let userInfo = info && JSON.parse(info);
      let {id, current_tenant} = userInfo || {};
      let popInternet = await InterNetCheck();

      // return if user logged out
      if (!token || !popInternet || !id) return;

      let orders = await fetchCompletedOrdersLocally(id, current_tenant);
      if (orders.length > 0) {
        // 30 seconds
        const thirtySecondsInMilliseconds = 30 * 1000;

        // Filter orders created 30 seconds before
        const filteredOrders = orders.filter(order => {
          let currentTime = new Date();
          const updatedAtTime = new Date(order.updated_at);

          // Time difference in milliseconds
          const timeDifference = currentTime - updatedAtTime;
          return timeDifference >= thirtySecondsInMilliseconds;
        });

        if (filteredOrders.length > 0) {
          const mappedOrders = filteredOrders.map(order => ({ tenant: current_tenant, user_id: id, order_id: order.order_id, status: order.flag }));
          disPatch(detectOrdersDiscrepancies(mappedOrders));
        }
      }
    }, TIMER_MS);

    return () => {
      clearInterval(interval);
    }
  }, [])

  useEffect(() => {
    const handleOrdersData = async () => {
      let {result} = props.ordersData || {};
      // return if there's no item in result
      if (result?.length <= 0) return;

      result.forEach(async item => {
        let {tenant, user_id, order_id, status, discrepancy} = item || {};
        if (discrepancy) {
          await updateOrdersFlag(tenant, user_id, order_id, {flag: 'reported'})
        } else {
          await updateOrdersFlag(tenant, user_id, order_id, {flag: 1})
        }
      });
    }

    if (props.ordersData) {
      handleOrdersData();
    }
  }, [props.ordersData])

  useEffect(()=>{
    if(props.dashboardData){
      disPatch(SetDashboardData(props.dashboardData));
    }

  },[props.dashboardData])

  const menuVisible =
    openDrawer && currentRoute !== '' && currentRoute !== 'SignIn';
  const contentMarginLeft =
    menuVisible && windowWidth >= 768
      ? menuMode === MENU_COLLAPSED
        ? 64
        : Math.min(200, windowWidth * 0.8)
      : 0;

  return (
    show && initialRoute && (
      <React.Fragment>
        {menuVisible && (
          <Drawer
            closeDrawer={closeDrawer}
            currentRoute={currentRoute}
            checkFunctionHere={checkFunctionHere}
            menuMode={menuMode}
            toggleMenuMode={toggleMenuMode}
          />
        )}
        <View style={{flex: 1, marginLeft: contentMarginLeft}}>
        <NavigationContainer
          ref={navigationRef}
          theme={blackNavigationTheme}
          style={{zIndex: -1}}
          onReady={() =>
            setCurrentRoute(
              navigationRef.current?.getCurrentRoute()?.name || ''
            )
          }
          onStateChange={() =>
            setCurrentRoute(
              navigationRef.current?.getCurrentRoute()?.name || ''
            )
          }>
          <Stack.Navigator
            initialRouteName={initialRoute}
            style={{zIndex: -1}}>
            <Stack.Screen
              name="SignIn"
              component={SignIn}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                currentSocket: props.currentSocket
                // socketFun : ()=>{props.socketFun()}
              }}
              options={{headerShown: false}}
            />
            <Stack.Screen
              name="OrderList"
              component={OrderList}
              path="/123"
              options={{
                title: 'List',
                headerStyle: {
                  backgroundColor: '#336599'
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontSize: 22
                },
                headerLeft: null,
                headerLeft: () => <DrawerButton />
              }}
            />
            <Stack.Screen
              name="OrderDetail"
              component={OrderDetail}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Order Detail"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ViewInventoryReport"
              component={ViewInventoryReport}
              options={({route}) => (
                {
                header: () => (
                  <CustomHeader
                    title={route.params?.mode === 'receive' ? "Receive Record" : 'Recount Record'}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }
              )}
            />
            <Stack.Screen
              name="PushInventory"
              component={PushInventory}
              options={({route}) => ({
                header: () => (
                  <CustomHeader
                    title="Push to Shopify"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              })}
            />
            <Stack.Screen
              name="ShippingLabel"
              component={ShippingLabel}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Shipping Label"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />

            <Stack.Screen
              name="ScanPack"
              component={ScanPack}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                socketFun: () => {
                  props.socketFun();
                },
                isConnected:isConnected,
                modalVisible:props.modalVisible
                // modalVisible: () => {
                //   props.modalVisible;
                // }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title={I18n.t("scanPack.headerLabel")}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={true}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ScanPackItem"
              component={ScanPackItemComponent}
              initialParams={{
                item: navBarShow,
                restart: restartFlag,
                restartButton: restartButton,
                changeHeading: changeHeading,
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                socketFun: () => {
                  props.socketFun();
                },
                handlePrint: urlcheck => {
                  props.handlePrint(urlcheck);
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title={I18n.t("scanPack.headerLabel")}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    height={windowWidth > 900 ? 64 : 40}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => RootNavigation.navigate('ScanPack')}
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ScanToCart"
              component={ScanToCartHome}
              initialParams={{
                item: navBarShow,
                restart: restartFlag,
                restartButton: restartButton,
                changeHeading: changeHeading,
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                socketFun: () => {
                  props.socketFun();
                },
                handlePrint: urlcheck => {
                  props.handlePrint(urlcheck);
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title={pickComplete? "Processing Orders":"Scan To Cart"}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    height={windowWidth > 900 ? 64 : 40}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => RootNavigation.navigate('ScanPack')}
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductSearch"
              component={ProductSearch}
              initialParams={{
                item: navBarShow,
                restart: restartFlag,
                restartButton: restartButton,
                changeHeading: changeHeading,
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                userInfo: props.userInfo
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Product Search"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => RootNavigation.navigate('ScanPack')}
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={true}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductSearchGrid"
              component={ProductSearchGrid}
              options={{
                header: () => (
                  <CustomHeader
                    title="Product Search"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => RootNavigation.navigate('ScanPack')}
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={true}
                    progressCount={props.progressCount}
                    actionMsg={props.actionMsg}
                    progressLabel={props.progressLabel}
                  />
                )
              }}
            />
            <Stack.Screen
              name="OrderSearch"
              component={OrderSearch}
              initialParams={{
                item: navBarShow,
                restart: restartFlag,
                restartButton: restartButton,
                changeHeading: changeHeading,
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                userInfo: props.userInfo
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Order List"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => RootNavigation.navigate('ScanPack')}
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={true}
                    progressCount={props.progressCount}
                    actionMsg={props.actionMsg}
                    progressLabel={props.progressLabel}
                  />
                )
              }}
            />
            <Stack.Screen
              name="Settings"
              component={Settings}
              initialParams={{
                item: navBarShow,
                restart: restartFlag,
                restartButton: restartButton,
                changeHeading: changeHeading,
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                GetBothSettings: props.GetBothSettings,
                userInfo: props.userInfo
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Settings"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => {
                      disPatch(MountComponent(!mountComponent))
                      RootNavigation.navigate('ScanPack')}
                    }
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={true}
                  />
                )
              }}
            />
            <Stack.Screen
              name="AutomationRules"
              component={AutomationRulesScreen}
              initialParams={{
                openMenuDrawer: () => {
                  handelDrawer((openDrawer = true));
                  disPatch(CheckIsMenuOpen(true));
                }
              }}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="AdminTenants"
              component={AdminTenants}
              initialParams={{
                openMenuDrawer: () => {
                  handelDrawer((openDrawer = true));
                  disPatch(CheckIsMenuOpen(true));
                }
              }}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="AdminTenantPage"
              component={AdminTenantPage}
              initialParams={{
                openMenuDrawer: () => {
                  handelDrawer((openDrawer = true));
                  disPatch(CheckIsMenuOpen(true));
                }
              }}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="AdminUtilities"
              component={AdminUtilities}
              initialParams={{
                openMenuDrawer: () => {
                  handelDrawer((openDrawer = true));
                  disPatch(CheckIsMenuOpen(true));
                }
              }}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="CostCalculator"
              component={CostCalculatorScreen}
              initialParams={{
                openMenuDrawer: () => {
                  handelDrawer((openDrawer = true));
                  disPatch(CheckIsMenuOpen(true));
                }
              }}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="Dashboard"
              component={Dashboard}
              initialParams={{
                item: navBarShow,
                restart: restartFlag,
                restartButton: restartButton,
                changeHeading: changeHeading,
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                GetBothSettings: props.GetBothSettings,
                userInfo: props.userInfo
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Dashboard"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    isTouchableTitle={true}
                    onPressTitle={() => {
                      // disPatch(MountComponent(!mountComponent))
                      // RootNavigation.navigate('ScanPack')
                    }}
                    onClick={() => alertShowHandle(false)}
                    Close={Close}
                    showSync={true}
                  />
                )
              }}
            />
            <Stack.Screen
              name="PPMTestDataGenerator"
              component={PPMTestDataGenerator}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="PPM Test Data Generator"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductEdit"
              component={ProductEdit}
              options={{
                title: 'Edit Product',
                headerStyle: {
                  backgroundColor: '#336599'
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontSize: 22
                }
              }}
            />
            <Stack.Screen
              name="ProductDetail"
              component={ProductDetail}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                socketFun: arg => {
                  props.socketFun(arg);
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Product Detail"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ItemsDetail"
              component={ItemsDetail}
              options={{
                title: 'Items Detail',
                headerStyle: {
                  backgroundColor: '#336599'
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontSize: 22
                }
              }}
            />
            <Stack.Screen
              name="PutWall"
              component={PutWall}
              initialParams={{
                closeDrawer: () => {
                  closeDrawerFromContent();
                },
                socketFun: () => {
                  props.socketFun();
                },
                isConnected: isConnected,
                modalVisible: props.modalVisible
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title={I18n.t('scanPack.headerLabel')}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    isTouchableTitle={true}
                    onPressTitle={() => disPatch(resetProductFirst())}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={true}
                  />
                )
              }}
            />
            <Stack.Screen
              name="Select Product to add to Order"
              component={AddItemToOrder}
              options={{
                headerStyle: {
                  backgroundColor: '#336599'
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontSize: 22
                }
              }}
            />
            <Stack.Screen
              name="PackingCam"
              component={PackingCam}
              options={{
                header: () => (
                  <CustomHeader
                    title="Packing Cam"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ScanRecount"
              component={ScanRecount}
              options={{
                header: () => (
                  <CustomHeader
                    title="Recount Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ScanReceive"
              component={ScanReceive}
              options={{
                header: () => (
                  <CustomHeader
                    title="Receive Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="InventoryReport"
              component={InventoryReport}
              options={({ route }) => ({
                header: () => (
                  <CustomHeader
                  title={route.params?.mode
                    ? route.params.mode.charAt(0).toUpperCase() + route.params.mode.slice(1)
                    : "Inventory Report"}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              })}
            />
            <Stack.Screen
              name="ArchivedReceivingReports"
              component={ArchivedReceivingReports}
              options={({ route }) => ({
                header: () => (
                  <CustomHeader
                  title={route.params?.mode
                    ? route.params.mode.charAt(0).toUpperCase() + route.params.mode.slice(1)
                    : "Inventory Report"}
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              })}
            />
            <Stack.Screen
              name="PrintJob"
              component={printJob}
              options={{
                header: () => (
                  <CustomHeader
                    title="Print Jobs"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="Orders"
              component={AllOrders}
              initialParams={{
                socketFun: () => {
                  props.socketFun();
                }
              }}
              options={{
                header: () => (
                  <CustomHeader
                    title="Orders"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                    progressCount={props.progressCount}
                    actionMsg={props.actionMsg}
                    progressLabel={props.progressLabel}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductReceive"
              component={ProductReceive}
              options={{
                header: () => (
                  <CustomHeader
                    title="Receive Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductRecount"
              component={ProductRecount}
              options={{
                header: () => (
                  <CustomHeader
                    title="Recount Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="CountReceive"
              component={CountReceive}
              options={{
                header: () => (
                  <CustomHeader
                    title="Receive Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="CountRecount"
              component={CountRecount}
              options={{
                header: () => (
                  <CustomHeader
                    title="Recount Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductListReceive"
              component={ProductListReceive}
              options={{
                header: () => (
                  <CustomHeader
                    title="Receive Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
            <Stack.Screen
              name="ProductListRecount"
              component={ProductListRecount}
              options={{
                header: () => (
                  <CustomHeader
                    title="Recount Inventory"
                    username={props.userInfo && props.userInfo.username}
                    tenant={props.userInfo && props.userInfo.current_tenant}
                    onPress={() => {
                      handelDrawer((openDrawer = true));
                      disPatch(CheckIsMenuOpen(true));
                    }}
                    syncButtonHandle={() => syncButtonHandle()}
                    alertShow={alertShow}
                    windowWidth={windowWidth}
                    showSync={false}
                  />
                )
              }}
            />
          </Stack.Navigator>
        </NavigationContainer>
        <CartCompleteConfetti />
        </View>
      </React.Fragment>
    )
  );
}

const mapStateToProps = state => {
  return {
    userInfo: state.user.userInfo,
    ordersData: state.scanpack.orders_data,
    ordersUpdated: state.order.ordersUpdated
  };
};

const mapDispatchToProps = {
  UserInfo
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);
